/* eslint-disable react-hooks/exhaustive-deps */
import { IMPORT_REQUEST_TYPE } from "features/Purchase/constant";
import { useGetVouchersCampaignClone } from "hooks/campaign";

import { useEffect, useState } from "react";
import { v4 as uuidv4 } from "uuid";

export const useOrderPromo = ({ form, promotionCampaignID, isUpdate }) => {
  const [dataTableProduct, setDataTableProduct] = useState([]);
  const [isInitialized, setIsInitialized] = useState(false);

  const params = {
    filters: {
      promotionCampaignIDs: promotionCampaignID ? [promotionCampaignID] : [],
      statuses: [],
    },
    pagination: {
      limit: 50, // Lấy nhiều voucher để map với tiers
      offset: 0,
    },
  };

  const { data: vouchersData, loading: loadingVouchers } = useGetVouchersCampaignClone(
    promotionCampaignID ? params : null
  );

  const handleDeleteProduct = (id, index) => {
    const formData = form.getFieldsValue();
    const promoOrderItems = formData?.promoOrderItems || [];
    const dataFormDelete = promoOrderItems.filter((_, idx) => idx !== index);
    form.setFieldsValue({
      ...formData,
      promoOrderItems: dataFormDelete,
    });
    const dataTableDelete = dataTableProduct?.filter((item) => item.id !== id);
    setDataTableProduct(dataTableDelete);
  };

  const initialValues = {
    items: [],
    warehouseID: null,
    type: IMPORT_REQUEST_TYPE.DOMESTIC,
  };

  const handleKeyPress = (event) => {
    if (event.key === "Enter") {
      event.preventDefault();
    }
  };

  const handleAddItem = () => {
    const id = uuidv4();
    const formData = form.getFieldsValue();
    const newFormItem = { productID: id };
    form.setFieldsValue({
      ...formData,
      promoOrderItems: [...(formData.promoOrderItems || []), newFormItem],
    });
    setDataTableProduct([...(dataTableProduct || []), { id }]);
  };

  const handleCopyItem = (index) => {
    const id = uuidv4();
    const values = form.getFieldsValue();
    const promoOrderItems = values.promoOrderItems || [];
    const source = promoOrderItems[index];

    // Deep clone the source item
    const cloned = source ? JSON.parse(JSON.stringify(source)) : {};
    cloned.productID = id;

    // Create new items array with cloned item inserted after index
    const newItems = [...promoOrderItems.slice(0, index + 1), cloned, ...promoOrderItems.slice(index + 1)];

    form.setFieldsValue({ ...values, promoOrderItems: newItems });

    const newData = [...(dataTableProduct || [])];
    newData.splice(index + 1, 0, { id });
    setDataTableProduct(newData);
    return id;
  };

  // Convert voucher data từ API sang form data
  const convertVoucherToFormData = (voucher) => {
    const tier = voucher?.promotionCampaignTier;
    if (!tier) return null;

    const id = uuidv4();

    // Map conditionProductGroups
    // Logic: Dựa vào productAppliedNumber để xác định
    // - productAppliedNumber === 0 → Tất cả sản phẩm (conditionProductGroups = undefined)
    // - productAppliedNumber > 0 → Dựa vào conditionProductGroups và conditionPromotionProducts
    const rawConditionProductGroups = tier?.conditionProductGroups;
    const productAppliedNumber = tier?.productAppliedNumber || 0;
    let conditionProductGroups = undefined;

    if (productAppliedNumber > 0 && rawConditionProductGroups && rawConditionProductGroups.length > 0) {
      conditionProductGroups = rawConditionProductGroups.map((group) => {
        const conditionPromotionProducts = (group?.conditionPromotionProducts || []).map((product) => ({
          productID: product?.productID,
          type: "CONDITION_PRODUCT",
        }));

        return {
          quantity: group?.quantity || 1,
          conditionPromotionProducts: conditionPromotionProducts,
          type: "CONDITION_PRODUCT",
          conditionProductType: group?.conditionProductType || "INCLUDED",
        };
      });
    }

    const sellerSegmentType = tier?.sellerUserSegment?.type || "ALL";
    const sellerSegmentID = tier?.sellerUserSegment?.id || tier?.sellerSegmentID;
    const sellerAppliedNumber = tier?.sellerAppliedNumber || 0;

    // KHÔNG copy voucher info - để user nhập mới
    return {
      productID: id,
      minAmount: tier?.minAmount || null,
      discountType: tier?.discountType || "DISCOUNT_PERCENTAGE",
      discountAmount: tier?.discountAmount || null,
      limitType: tier?.maxDiscountAmount ? "LIMITED" : "UNLIMITED",
      maxDiscountAmount: tier?.maxDiscountAmount || null,
      type: "DISCOUNT_ORDER",
      budgetAmount: tier?.budgetAmount || null,
      maxQuantityPerSellerLimitType: tier?.maxQuantityPerSeller ? "LIMITED" : "UNLIMITED",
      maxQuantityPerSeller: tier?.maxQuantityPerSeller || null,
      sellerSegmentID: sellerSegmentID,
      sellerSegmentType: sellerSegmentType,
      targetCustomerFilterType: sellerSegmentType,
      conditionProductGroups: conditionProductGroups,
      productAppliedNumber: productAppliedNumber,
      sellerAppliedNumber: sellerAppliedNumber,
      appliedTierID: tier?.id,
      hasVoucher: false, // Không có voucher, để user nhập mới
      id: id,
    };
  };

  // Initialize form data từ vouchers khi clone
  useEffect(() => {
    if (isUpdate && vouchersData && vouchersData.length > 0 && !isInitialized && !loadingVouchers) {
      const formItems = vouchersData.map(convertVoucherToFormData).filter(Boolean);
      const tableData = formItems.map((item) => ({ id: item.id }));

      form.setFieldsValue({
        promoOrderItems: formItems,
      });

      setDataTableProduct(tableData);
      setIsInitialized(true);
    }
  }, [vouchersData, isUpdate, isInitialized, loadingVouchers]);

  // Fallback: Initialize empty form nếu không có vouchers
  useEffect(() => {
    if (!isUpdate && !isInitialized) {
      form.setFieldsValue({ ...initialValues });
      setIsInitialized(true);
    }
  }, [isUpdate, isInitialized]);

  return {
    form,
    dataTableProduct,
    handleDeleteProduct,
    handleKeyPress,
    handleAddItem,
    handleCopyItem,
  };
};
